export const pushEventToOptimizely = (eventName, data) => {
	window?.["optimizely"]?.push({
		type: "event",
		eventName,
		properties: {
			...data,
		},
	});
};

export const insuranceDataObject = (insurance) => {
	return {
		item_name: insurance.name,
		item_id: insurance.id,
		price: insurance.price,

		item_division_id: 0,
		item_division_name: "General",
		item_group_id: 95,
		item_group_name: "Insurance",
		item_brand: "Komplett",
		item_stock_status: "digital",
		item_category: "Services",
		item_category2: "Insurance",
		item_category3: insurance.variant,
	};
};
